import { Box, Container, Grid, Typography } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "@material-ui/styles";
import MainButton from "../../../../../shared/components/MainButton";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import ResponsiveDialog from "../../../../../shared/components/ResponsiveDialog";
import Text from "../../../../../shared/components/Text";
import ResponsiveLayout from "../../../../../shared/components/ResponsiveLayout";
import { ACTION_EXCEPTIONS } from "../../../../../../utils/getActionException";

export const RetryVideoIdActionExceptions = [
  ACTION_EXCEPTIONS.INVALID_DOCUMENT_NUMBER_EXCEPTION,
  ACTION_EXCEPTIONS.INVALID_ELECTRONIC_ID_INFORMATION_EXCEPTION,
  ACTION_EXCEPTIONS.INVALID_DATE_EXCEPTION,
  ACTION_EXCEPTIONS.INVALID_ISO3166_EXCEPTION,
  ACTION_EXCEPTIONS.USER_DETAILS_DOCUMENT_NUMBER_DOES_NOT_MATCH_KYC_EXCEPTION,
];

export default function RetryElectronicId({ onRetryElectronicId }) {
  const { palette } = useTheme();
  const {
    dispatch,
    state: { actionException, videoId },
  } = useContext(ProcessContext);

  const [showRetryScreen, setShowRetryScreen] = useState(false);

  useEffect(() => {
    if (RetryVideoIdActionExceptions.includes(actionException)) {
      setShowRetryScreen(true);
    }
  }, [actionException]);

  const handleRetry = () => {
    if (!videoId) return;
    setShowRetryScreen(false);
    onRetryElectronicId();
    videoId.destroy();
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: {
        kycAuthorization: undefined,
        actionException: undefined,
        videoId: undefined,
      },
    });
  };

  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "Retry electronic id dialog",
      }}
      className={"appear-anim"}
      displayCondition={true}
      fullScreenCondition={true}
      open={showRetryScreen}
    >
      <Container style={{ padding: "1rem 1rem", height: "100%" }}>
        <ResponsiveLayout>
          <Box />
          <Box
            mt={4}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className="appear-anim"
          >
            <ThemedAsset
              id={assetIds.ICON_FAIL}
              width={50}
              height={50}
              style={{ color: palette.error.main }}
            />
            <Grid
              container
              display="flex"
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ paddingTop: 20 }}
            >
              <Typography
                color={palette.text.title}
                variant={"h6"}
                className={"mb-1 transition-all"}
              >
                <strong>
                  <Text tId={"OOPS_SOMETHING_WENT_WRONG"} />
                </strong>
              </Typography>
              <Typography
                variant={"body2"}
                className={"mb-3 mt-2 transition-all"}
                style={{
                  color: palette.text.primary,
                  textAlign: "left",
                  overflow: "hidden",
                  whiteSpace: "break-spaces",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                <Text tId={actionException} />
              </Typography>
            </Grid>
          </Box>
          <Box />
          <Box>
            <MainButton fullWidth onClick={() => handleRetry()}>
              <Text tId={"RETRY_VIDEO_ID_BUTTON"} />
            </MainButton>
          </Box>
        </ResponsiveLayout>
      </Container>
    </ResponsiveDialog>
  );
}
